import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DialogTitle as MuiDialogTitle, } from '@mui/material';
import { useTranslation } from '@zurich/common/hooks';
import { styled } from '../../utils';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
export function DialogTitle(props) {
    const { children, iconVariant, warning, ...otherProps } = props;
    const { t } = useTranslation();
    return (_jsx(DialagTitleStyled, { component: "div", variant: "inherit", ...otherProps, children: _jsxs(DialagTypoStyled, { variant: "subtitle1", component: "h2", children: [iconVariant && (_jsxs(StyledTypographyWrapper, { warning: warning ?? false, children: [_jsx(IconStyled, { variant: iconVariant }), _jsx("span", { children: t('common:alert') })] })), children] }) }));
}
const DialagTitleStyled = styled(MuiDialogTitle)(({ theme }) => ({
    margin: 0,
    padding: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1.5),
    },
    paddingBottom: theme.spacing(1),
    flex: '1 1 auto',
    justifyContent: 'flex-start',
}));
const StyledTypographyWrapper = styled('div')(({ theme, warning }) => ({
    color: warning ? theme.palette.error.light : 'inherit',
    display: 'flex',
    paddingRight: theme.spacing(1),
}));
const DialagTypoStyled = styled(Typography)({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
});
const IconStyled = styled(Icon)(({ theme }) => ({
    paddingRight: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
}));
